<template>
  <div class="kvass-radio">
    <template v-for="(item, index) in items">
      <label :for="`${_uid}_${index}`" class="kvass-radio__wrapper">
        <input
          type="radio"
          :value="item.value"
          :name="`kvass-radio_${_uid}`"
          :disabled="item.disabled"
          v-model="inputVal"
          :id="`${_uid}_${index}`"
          class="kvass-radio__input"
          checked
        />

        <div class="kvass-radio__radio"></div>
        <div>
          <span class="kvass-radio__label">
            <slot name="label" :item="item">
              {{ item.label }}
            </slot>
          </span>
          <span class="kvass-radio__sublabel">
            <slot name="sublabel" :item="item">
              {{ item.sublabel }}
            </slot>
          </span>
        </div>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Boolean, Number],
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style lang="scss">
.kvass-radio {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  justify-content: left;

  &__wrapper {
    cursor: pointer;
    display: inline-flex;
    margin-right: 10px;

    &:has(input:disabled) {
      cursor: not-allowed;
    }
  }

  &__input {
    display: none;

    &:checked {
      & + .kvass-radio__radio {
        border-color: var(--primary, #1d56d8);
        &:after {
          opacity: 1;
        }
      }
    }

    &:disabled {
      & + .kvass-radio__radio {
        border-color: var(--grey);
        background-color: var(--light-grey);
      }
    }
  }

  &__radio {
    $size: 1.5rem;
    width: $size;
    height: $size;
    border: 1px solid var(--border-color, #eaeaea);
    border-radius: 30rem;
    margin-right: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    &:after {
      content: '';
      width: $size / 2;
      height: $size / 2;
      display: block;
      background: var(--primary, #1d56d8);
      border-radius: 30rem;
      opacity: 0;
    }
  }

  &__label {
    align-self: flex-end;
    font-size: 1rem;
  }

  &__sublabel {
    display: block;
    opacity: 0.5;
  }
}
</style>
